import { DocumentData } from "@angular/fire/firestore";
import { DrinkSchedule } from "./drink.schedule.model";
import { DayOfWeekSchedule } from "src/app/core/product/enums";
import { DrinkPricesBuilder } from "../prices/drink.prices.builder";
import { DrinkException } from "../exceptions/drink.exceptions.model";

export class DrinkScheduleBuilder {
  private _isDailyPrice: boolean;
  private _price: number;
  private _weekdayPrices: DrinkPricesBuilder;

  
  private _activeWeekdays: DayOfWeekSchedule;
  private _exceptions: DrinkException[];

  constructor() {
    this.default();
  }

  public get hasActiveWeekday(): boolean {
    return (
      this.isActiveFriday ||
      this.isActiveMonday ||
      this.isActiveSaturday ||
      this.isActiveThursday ||
      this.isActiveTuesday ||
      this.isActiveWednesday ||
      this.isActiveSunday
    );
  }

  public get isDailyPrice(): boolean {
    return this._isDailyPrice;
  }

  public set isDailyPrice(b: boolean) {
    this._isDailyPrice = b;
  }

  public get price(): number {
    return this._price;
  }

  public set price(n: number) {
    this._price = n;
  }
  public get activeWeekdays(): DayOfWeekSchedule {
    return this._activeWeekdays;
  }
  public set activeWeekdays(dow: DayOfWeekSchedule) {
    this._activeWeekdays = dow;
  }
  public get weekdayPrices(): DrinkPricesBuilder {
    return this._weekdayPrices;
  }
  public get isActiveMonday(): boolean {
    return this._activeWeekdays.monday;
  }
  public get isActiveTuesday(): boolean {
    return this._activeWeekdays.tuesday;
  }
  public get isActiveWednesday(): boolean {
    return this._activeWeekdays.wednesday;
  }
  public get isActiveThursday(): boolean {
    return this._activeWeekdays.thursday;
  }
  public get isActiveFriday(): boolean {
    return this._activeWeekdays.friday;
  }
  public get isActiveSaturday(): boolean {
    return this._activeWeekdays.saturday;
  }
  public get isActiveSunday(): boolean {
    return this._activeWeekdays.sunday;
  }
  public get priceOnMonday(): number {
    return this._weekdayPrices.monday;
  }

  public get priceOnTuesday(): number {
    return this._weekdayPrices.tuesday;
  }

  public get priceOnWednesday(): number {
    return this._weekdayPrices.wednesday;
  }
  public get priceOnThursday(): number {
    return this._weekdayPrices.thursday;
  }
  public get priceOnFriday(): number {
    return this._weekdayPrices.friday;
  }
  public get priceOnSaturday(): number {
    return this._weekdayPrices.saturday;
  }
  public get priceOnSunday(): number {
    return this._weekdayPrices.sunday;
  }
  public get exceptions(): DrinkException[] {
    return this._exceptions;
  }
  public addException(exception: DrinkException) {
    this._exceptions.push(exception);
  }
  public removeException(exception: DrinkException) {
    for (var i = 0; i < this._exceptions.length; i++) {
      if (this._exceptions[i].compare(exception)) {
        this._exceptions.splice(i, 1);
        return;
      }
    }
  }
  public get exceptionsOnMonday(): DrinkException[] {
    return this._exceptions.filter(e => e.day == "monday");
  }
  public get exceptionsOnTuesday(): DrinkException[] {
    return this._exceptions.filter(e => e.day == "tuesday");
  }
  public get exceptionsOnWednesday(): DrinkException[] {
    return this._exceptions.filter(e => e.day == "wednesday");
  }
  public get exceptionsOnThursday(): DrinkException[] {
    return this._exceptions.filter(e => e.day == "thursday");
  }
  public get exceptionsOnFriday(): DrinkException[] {
    return this._exceptions.filter(e => e.day == "friday");
  }
  public get exceptionsOnSaturday(): DrinkException[] {
    return this._exceptions.filter(e => e.day == "saturday");
  }
  public get exceptionsOnSunday(): DrinkException[] {
    return this._exceptions.filter(e => e.day == "sunday");
  }

  public default() {
    this._isDailyPrice = true;
    this._price = null;
    this._weekdayPrices = new DrinkPricesBuilder();
    this._activeWeekdays = DayOfWeekSchedule.all();
    this._exceptions = [];
  }

  public load(data: DocumentData): DrinkScheduleBuilder {
    this._isDailyPrice = data.isDailyPrice;
    this._price = data.price;
    this._activeWeekdays = new DayOfWeekSchedule(data.activeWeekdays);
    this._weekdayPrices = new DrinkPricesBuilder().load(data.weekdayPrices);
    this._exceptions =
      data.exceptions == null
        ? []
        : data.exceptions.map((e: DocumentData) =>
            new DrinkException(e.day).load(e)
          );

    return this;
  }

  public edit(data: DrinkSchedule): DrinkScheduleBuilder {
    this._isDailyPrice = data.isDailyPrice;
    this._price = data.price;
    this._activeWeekdays = new DayOfWeekSchedule(data.activeWeekdays);
    this._weekdayPrices = new DrinkPricesBuilder().edit(data.weekdayPrices);
    this._exceptions = data.exceptions.map(e =>
      new DrinkException(e.day).edit(e)
    );
    return this;
  }

  public toJSON = () => ({
    price: this._price,
    isDailyPrice: this._isDailyPrice,
    activeWeekdays: this._activeWeekdays.toJSON(),
    weekdayPrices: this._weekdayPrices.toJSON(),
    exceptions: this.exceptions.map(e => e.toJSON())
  });
}
